module.exports = __webpack_public_path__ + "img/timer.08e47088.svg";